import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

import { componentSets } from '../../util/util';

class MultiFoodReportSelector extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.setReport(event.target.value);
  }

  render() {
    // don't show claimables in multi-food result
    const filteredComponentSets = componentSets.filter(set => set.key !== 'claimable');
    return (
      <FormGroup>
        <ControlLabel>select component set to display</ControlLabel>
        <FormControl
          componentClass="select"
          name="componentSet"
          value={this.props.selected}
          onChange={this.handleChange}
        >
          {filteredComponentSets.map((set) => (
            <option value={set.key} key={set.key}>{set.title}</option>
          ))}
        </FormControl>
      </FormGroup>
    );
  }
}

MultiFoodReportSelector.propTypes = {
  selected: PropTypes.string.isRequired,
  setReport: PropTypes.func.isRequired,
};

export default MultiFoodReportSelector;



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodReportSelector.js